<script lang="ts">
import { defineComponent, unref } from 'vue';

import { makeDisabledProps, makeGroupItemProps, useGroupItem } from '../../composable';

import { CdsSlideGroupSymbol } from './CdsSlideGroup.vue';

export const componentName = 'CdsSlideGroupItem';
export default defineComponent({
  name: componentName,
  props: {
    ...makeGroupItemProps(),
    ...makeDisabledProps()
  },
  emits: {
    'group:selected': (value: { value: boolean }) => true
  },
  setup(props, { slots }) {
    const slideGroupItem = useGroupItem(props, CdsSlideGroupSymbol);

    return () =>
      slots.default?.({
        isSelected: unref(slideGroupItem.isSelected),
        select: slideGroupItem.select,
        toggle: slideGroupItem.toggle,
        selectedClass: unref(slideGroupItem.selectedClass)
      });
  }
});
</script>
